import React, { useEffect, useState,useRef, useContext } from "react";
import { Driver } from "../../objects/policy";
import { Button, MenuItem, Select, TextField,FormControl, InputLabel,ToggleButtonGroup,ToggleButton } from "@mui/material";
import {useForm, Controller} from "react-hook-form";

import { v4 as uuidv4 } from 'uuid';
import {DatePicker, DateField,LocalizationProvider  } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { current } from "@reduxjs/toolkit";
import { useFetcher } from "react-router-dom";
import EditDriverForm from "../EditDriverForm";
import SettingsContext from "../../store/settingscontext";
import { DriveEtaRounded } from "@mui/icons-material";


function ListDrivers(props: any) {
    const settings = useContext<any>(SettingsContext);
    const{drivers, removeDriverAction, onUpdateAction, policyState } = props;

    const [isPageLoad, setIsPageLoad] = useState(true);
    let counter = 0;

    const[currentKey, setCurrentKey] = useState("");
    const[stateDrivers, setStateDrivers] = useState<Driver[]>([]);

    useEffect(()=>{

        setStateDrivers(drivers as Driver[]);  
        setIsPageLoad(false);
    }, [drivers])

    function onRemoveDriver(e: any, driverNumber: any){
        var removedDrivers = removeDriverAction(driverNumber);

        setStateDrivers(removedDrivers);
    }



    function editDriver(e: any, key: any) {        
        var index = e.target.dataset.containerkey;
        if(index === currentKey){
            setCurrentKey("");
        } else{
            setCurrentKey(index);
        }
        
        //document.querySelector(".container-edit-driver[data-index="+key+"]")?.classList.toggle("expanded");

        var containerEditDriver = document.querySelector(".container-edit-driver[data-index='"+key+"']")
        document.querySelector(".row-edit-driver[data-index='"+key+"'")?.classList.toggle("rounded-br-lg");
        document.querySelector(".row-edit-driver[data-index='"+key+"'")?.classList.toggle("rounded-bl-lg");
    }

   
   

    return (
        <>
            
            <div className="list-edit-drivers">
               
                {
                    (stateDrivers as Driver[])?.map((v, k)=>{
                        var containerKey = "container-edit-driver-" + counter;
                        console.log({driver_list_v_status: v.status});
                        

                        if(v.status === "REVIEW"){
                            return;
                        }

                        counter++
                        return <>
                        
                            <div key={uuidv4()} className="row-edit-driver bg-[#e5eff1] p-5 rounded-tl-lg rounded-tr-lg rounded-br-lg rounded-bl-lg" onClick={ (e)=>{  }}>
                                <span className="float-left font-bold text-lg text-ford-blue">{v.firstName} {v.lastName} {v.suffix}</span>
                                
                                <span data-containerkey={containerKey} 
                                    key={uuidv4()} 
                                    onClick={(e)=>{editDriver(e, v.driverNumber)}} className="float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer">Edit</span>

                                { v.relation !== "INSURED" ? 
                                        (<span 
                                            key={uuidv4()} 
                                            onClick={(e)=>{onRemoveDriver(e, v.driverNumber)}} 
                                            className="float-right text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer pr-5 text-red-700">Remove</span>) : 
                                        (<></>)
                                }
                                
                                <span key={uuidv4()} className="float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer hidden">Close</span>
                                <div className=" clear-both"></div>
                            </div>

                            {/* <EditDriverForm 
                                key={uuidv4()}
                                containerKey={containerKey} 
                                driverNumber = {v.driverNumber}
                                currentKey = {currentKey}
                                updateDriverAction={updateDriverAction}
                                setStateDrivers={setStateDrivers}
                                onClose={ (e:any) => { 
                                    setCurrentKey(""); 
                                } } 
                                 /> */}

                            <EditDriverForm 
                                parent="DRIVERS"
                                action = "EDIT"
                                driverNumber={v.driverNumber}
                                isVisible={currentKey === containerKey}
                                policyState={policyState}
                                drivers={drivers}
                                onCloseAction={ (e:any) => { 
                                    setCurrentKey(""); 
                                } }
                                onUpdateAction = {onUpdateAction} 
                                
                            />
                        
                        </>
                    })
                }
            </div>
        </>
    );
}


export default React.memo(ListDrivers);